import type { ContentItem } from '@/types/content';

export const newsItems: ContentItem[] = [
  {
    id: 'nw-2001',
    type: 'news',
    title: '星轨联赛第三赛段积分榜更新：榜首之争进入白热化',
    summary:
      '随着第三赛段收官，星轨联赛积分榜前四名分差缩小至 12 分以内，最后两个直通名额的归属悬念留到了季后赛。',
    event: '星轨联赛',
    category: '排名分析',
    date: '2026-10-10 08:30',
    author: '编辑部 · 陈望',
    source: '51每日大赛',
    tags: ['星轨联赛', '积分榜', '排名分析'],
    cover:
      'https://readdy.ai/api/search-image?query=Large%20digital%20leaderboard%20display%20in%20a%20modern%20esports%20arena%2C%20deep%20navy%20blue%20ambient%20light%20with%20orange%20data%20highlights%2C%20blurred%20crowd%20in%20foreground%2C%20cinematic%20broadcast%20style%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2001-cover&orientation=landscape',
    readTime: 4,
    content: [
      '星轨联赛第三赛段于昨日正式收官，官方今日更新了最新一期积分榜。与上一期相比，前四名的分差被进一步压缩，榜首之争进入白热化阶段。',
      '积分榜显示，目前排名第一的晨曦战队与第四名深渊战队之间的分差仅为 12 分，意味着季后赛前仍存在较大变数。多家分析机构认为，最后两个直通名额的争夺将成为接下来最受关注的看点。',
      '值得一提的是，星轨联赛本赛季的赛制强调稳定性，连续两个赛段保持净胜场上双的战队仅有极光战队一支。这也从侧面说明，稳定输出比单场爆发更具价值。',
      '根据赛程安排，季后赛将于本月底打响，届时积分榜前八的战队将进行双败淘汰赛，最终决出总冠军。',
    ],
  },
  {
    id: 'nw-2002',
    type: 'news',
    title: '极光杯八强对阵出炉，两大豪门提前相遇',
    summary:
      '极光杯抽签结果公布，极光战队与暗夜战队被分入同一半区，两支夺冠热门将在八强阶段提前上演强强对话。',
    event: '极光杯',
    category: '赛事动态',
    date: '2026-10-10 09:10',
    author: '编辑部 · 林澜',
    source: '51每日大赛',
    tags: ['极光杯', '对阵', '赛事动态'],
    cover:
      'https://readdy.ai/api/search-image?query=Bracket%20style%20tournament%20screens%20in%20a%20dark%20esports%20venue%2C%20deep%20blue%20lighting%20with%20orange%20accent%20glow%2C%20competitive%20atmosphere%2C%20analytical%20broadcast%20visual%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2002-cover&orientation=landscape',
    readTime: 3,
    content: [
      '极光杯今日完成了八强阶段的抽签仪式，结果一出便引发热议。极光战队与暗夜战队被分入同一半区，两支被广泛看好的夺冠热门将在八强阶段提前相遇。',
      '从历史交锋来看，两队近十次交手战成五胜五负，实力可谓旗鼓相当。分析人士指出，这场对决的胜负很可能取决于打野位置的发挥，谁能掌控野区节奏，谁就更接近胜利。',
      '另一半区中，星海战队被视为签运最佳的一方，其晋级之路相对平坦。不过竞技赛事的魅力正在于不确定性，任何轻敌都可能付出代价。',
    ],
  },
  {
    id: 'nw-2003',
    type: 'news',
    title: '暗夜争霸赛选手状态回暖，近十场胜率回升至 68%',
    summary:
      '经历赛季初的低迷后，暗夜争霸赛多支战队状态逐步回暖，整体胜率走势呈现明显上扬，竞争格局正在重构。',
    event: '暗夜争霸赛',
    category: '排名分析',
    date: '2026-10-10 10:20',
    author: '编辑部 · 周牧',
    source: '51每日大赛',
    tags: ['暗夜争霸赛', '状态回暖', '数据'],
    cover:
      'https://readdy.ai/api/search-image?query=Upward%20trending%20line%20charts%20displayed%20on%20sleek%20monitors%20in%20a%20dark%20control%20room%2C%20deep%20blue%20ambient%20light%20and%20orange%20data%20curves%2C%20analytical%20mood%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2003-cover&orientation=landscape',
    readTime: 5,
    content: [
      '数据显示，暗夜争霸赛的参赛战队在经历赛季初的低迷后，近期整体状态逐步回暖，近十场的平均胜率已回升至 68%。',
      '具体来看，中游战队的进步最为明显，多支战队通过调整战术体系与首发阵容，完成了从被动防守到主动进攻的转变。这一变化让整个赛区的竞争格局更具悬念。',
      '分析团队指出，状态回暖并非偶然，与赛程密度降低、队员恢复期延长密切相关。合理的轮换与体能管理，正在成为决定战队成绩的重要变量。',
      '随着常规赛进入尾声，这种上扬趋势能否延续到淘汰赛阶段，将是观察各队真实实力的关键窗口。',
    ],
  },
  {
    id: 'nw-2004',
    type: 'news',
    title: '数据分析：为何顶级选手在关键局失误频发？',
    summary:
      '本期数据专题聚焦“关键局效应”，通过表现指数曲线解析顶级选手在高压环境下的决策波动与原因。',
    event: '综合专题',
    category: '排名分析',
    date: '2026-10-10 11:00',
    author: '数据组 · 吴桐',
    source: '51每日大赛',
    tags: ['数据分析', '关键局', '心理因素'],
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20glowing%20graphs%20and%20neural%20curves%20on%20a%20dark%20blue%20background%2C%20orange%20highlight%20points%20marking%20drops%2C%20futuristic%20analytics%20aesthetic%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2004-cover&orientation=landscape',
    readTime: 6,
    content: [
      '在竞技赛事中，我们常常观察到一种现象：一些顶级选手在常规局面表现稳定，却在决胜局出现明显失误。本期数据专题尝试从表现指数曲线中找到答案。',
      '通过对本赛季数百场关键局的分析，数据组发现，选手的表现指数在决胜局平均下滑 15% 至 22%，其中击杀参与率与资源控制率的降幅最为显著。',
      '进一步拆解发现，失误并非均匀分布，而是集中在比赛的第 18 至 24 分钟——也就是经济差拉开、局势趋于紧张的时间段。这段区间内，选手的决策速度普遍放慢，而失误率却同步攀升。',
      '综合来看，“关键局效应”既是心理层面的压力传导，也是战术层面信息过载的结果。如何在高压下保持决策闭环，将成为每一位争冠选手的必修课。',
    ],
  },
  {
    id: 'nw-2005',
    type: 'news',
    title: '雷霆竞技场新赛季规则调整，节奏加快成主旋律',
    summary:
      '雷霆竞技场公布新赛季规则，限时推进与资源刷新机制同步调整，整体节奏明显加快，考验选手的即时决策能力。',
    event: '雷霆竞技场',
    category: '赛事动态',
    date: '2026-10-10 12:40',
    author: '编辑部 · 韩舟',
    source: '51每日大赛',
    tags: ['雷霆竞技场', '规则调整', '新赛季'],
    cover:
      'https://readdy.ai/api/search-image?query=Modern%20esports%20arena%20with%20countdown%20timer%20and%20speed%20motif%20lighting%2C%20deep%20blue%20and%20orange%20contrast%2C%20dynamic%20motion%20blur%20indicating%20fast%20pace%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2005-cover&orientation=landscape',
    readTime: 4,
    content: [
      '雷霆竞技场今日正式公布新赛季的规则调整方案，其中最受关注的当属限时推进机制的引入。新规则下，单局比赛的节奏将明显加快，留给选手的思考时间被大幅压缩。',
      '除限时推进外，资源刷新机制也同步调整，中立的战略资源点将更早出现，鼓励战队在前期展开更激烈的争夺。官方表示，此举旨在提升比赛的观赏性与对抗强度。',
      '多位教练在采访中表示，新规则对选手的即时决策能力提出了更高要求，以往依赖长时间运营的打法可能不再适用，战队需要重新设计战术体系。',
      '可以预见，新赛季的雷霆竞技场将呈现更加紧凑、更具冲击力的比赛画面，节奏加快将成为贯穿全季的主旋律。',
    ],
  },
  {
    id: 'nw-2006',
    type: 'news',
    title: '黎明锦标赛新人选手盘点：五位值得关注的潜力之星',
    summary:
      '黎明锦标赛涌现出一批表现出色的新人选手，他们在关键局中的稳定性超出预期，被视为下个赛季的重要变量。',
    event: '黎明锦标赛',
    category: '选手动态',
    date: '2026-10-10 14:00',
    author: '编辑部 · 沈知',
    source: '51每日大赛',
    tags: ['黎明锦标赛', '新人', '潜力'],
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20futuristic%20esports%20training%20room%20with%20young%20players%20silhouettes%20and%20glowing%20screens%2C%20deep%20blue%20ambient%20light%20with%20orange%20accents%2C%20hopeful%20competitive%20mood%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2006-cover&orientation=landscape',
    readTime: 5,
    content: [
      '本届黎明锦标赛不仅是老将的舞台，更是一批新人选手崭露头角的机会。经过多轮筛选，我们盘点了五位值得关注的新人选手。',
      '第一位是星海战队的贺川，他在小组赛中的表现指数稳定在 85 以上，关键局的心态尤为出色；第二位是苍穹战队的程野，其资源控制率位居新人榜首。',
      '此外，晨曦战队的顾北、深渊战队的江辞以及极光战队的替补选手苏晨，都在有限的出场时间里展现了不俗的潜力。',
      '评论人士认为，这批新人的共同特点是对新赛制适应更快、决策更大胆，他们很可能成为下个赛季格局变化的重要变量。',
    ],
  },
  {
    id: 'nw-2007',
    type: 'news',
    title: '深渊王者赛赛程过半，黑马战队能否延续奇迹？',
    summary:
      '深渊王者赛常规赛赛程过半，一支赛季初并不被看好的黑马战队跻身前四，其能否延续奇迹成为当前最大悬念。',
    event: '深渊王者赛',
    category: '赛事动态',
    date: '2026-10-10 15:45',
    author: '编辑部 · 高远',
    source: '51每日大赛',
    tags: ['深渊王者赛', '黑马', '赛程'],
    cover:
      'https://readdy.ai/api/search-image?query=Dramatic%20esports%20arena%20with%20a%20lone%20spotlight%20on%20a%20team%20of%20players%2C%20deep%20blue%20darkness%20with%20warm%20orange%20rim%20lighting%2C%20underdog%20triumph%20atmosphere%2C%20cinematic%20mood%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2007-cover&orientation=landscape',
    readTime: 4,
    content: [
      '深渊王者赛常规赛赛程已经过半，积分榜上最大的惊喜来自一支赛季初并不被看好的战队——苍穹战队。',
      '凭借稳健的运营与出色的团队协作，苍穹战队一路跻身前四，成为名副其实的黑马。数据团队分析认为，其成功的关键在于极低的非受迫性失误率。',
      '不过，赛程过半也意味着真正的考验即将开始。接下来的对手实力普遍更强，黑马能否延续奇迹，取决于其能否在高压对局中保持稳定。',
      '无论最终结果如何，苍穹战队的崛起已经为本届深渊王者赛增添了足够多的看点。',
    ],
  },
  {
    id: 'nw-2008',
    type: 'news',
    title: '从排名波动看选手稳定度：本赛季数据趋势解析',
    summary:
      '本期深度解析以“排名波动率”为切入点，量化选手的稳定度，揭示哪些名字在榜单中始终屹立不倒。',
    event: '综合专题',
    category: '排名分析',
    date: '2026-10-10 16:30',
    author: '数据组 · 吴桐',
    source: '51每日大赛',
    tags: ['排名分析', '稳定度', '数据趋势'],
    cover:
      'https://readdy.ai/api/search-image?query=Stable%20oscillating%20graph%20visualization%20on%20a%20dark%20blue%20dashboard%2C%20orange%20reference%20line%20marking%20consistency%2C%20clean%20analytical%20data%20aesthetic%2C%20futuristic%20control%20room%2C%20high%20detail%20editorial%20photography&width=800&height=450&seq=nw-2008-cover&orientation=landscape',
    readTime: 6,
    content: [
      '排名的每一次升降，背后都藏着选手状态的真实波动。本期深度解析以“排名波动率”为切入点，尝试量化选手的稳定度。',
      '我们的统计方法很简单：计算每位选手在过去三十天内的排名标准差。标准差越小，说明选手表现越稳定；反之则意味着状态起伏较大。',
      '结果显示，长期位居榜单前列的选手中，有近三分之一的人排名波动率极低，属于典型的高稳定度选手；而部分爆发型选手虽然单场表现亮眼，但波动率普遍偏高。',
      '对于战队而言，稳定度往往比单场爆发更具长期价值。如何在选拔与轮换中平衡这两类选手，将成为教练组的重要课题。',
    ],
  },
];